import React, { useEffect, useState } from 'react';
import './Loader.css';
import pinkyLogo from '../assets/Pinky cloud logo_page-0001.png';

const MIN_DISPLAY_MS = 1200;
const FADE_OUT_MS = 500;

const Loader = ({ onLoadingComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      // Call completion slightly after CSS fade-out finishes
      const doneTimer = setTimeout(() => {
        onLoadingComplete();
      }, FADE_OUT_MS + 50);
      return () => clearTimeout(doneTimer);
    }, MIN_DISPLAY_MS);

    return () => clearTimeout(timer);
  }, [onLoadingComplete]);

  return (
    <div className={`loader-overlay ${fadeOut ? 'fade-out' : ''}`}>
      <div className="loader-container">
        <img src={pinkyLogo} alt="Pinky Cloud" className="loader-logo" />
        <div className="loader-dots" aria-label="Chargement">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default Loader;